/**
 * Ticket Detail Tab Components
 * Backward compatibility re-exports from detail-tabs directory
 */
import {
  TicketDetailsTab,
  TicketUpdatesTab,
  TicketAttachmentsTab,
  TicketCompanyDisplay,
  ContactDetailsTab,
  TimeEntriesTab,
  TicketActivityTimelineTab,
  TicketTasksTab,
} from "./detail-tabs";

// Re-export individual components for backward compatibility
export {
  TicketDetailsTab,
  TicketUpdatesTab,
  TicketAttachmentsTab,
  TicketCompanyDisplay,
  ContactDetailsTab,
  TimeEntriesTab,
  TicketActivityTimelineTab,
  TicketTasksTab,
};

// Export grouped components object for backward compatibility
export const TicketDetailTabComponents = {
  TicketDetails: TicketDetailsTab,
  TicketUpdates: TicketUpdatesTab,
  TicketAttachments: TicketAttachmentsTab,
  TicketCompanyDisplay: TicketCompanyDisplay,
  TicketContactDisplay: ContactDetailsTab,
  TicketTimeEntriesDisplay: TimeEntriesTab,
  TicketActivityTimeline: TicketActivityTimelineTab,
  TicketTasksDisplay: TicketTasksTab,
};
